import { SVGProps } from "react";

const UserIcon = ({
  width = "28.2",
  height = "28.2",
  ...props
}: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="28.2"
    height="28.2"
    viewBox={`${(24 - parseFloat(width.toString())) / 2} ${
      (24 - parseFloat(height.toString())) / 2
    } ${width} ${height}`}
    fill="#363636"
    stroke="#363636"
    strokeWidth="0.2px"
  >
    <path
      d="M76.517,21.185a13.085,13.085,0,1,0-.16-.174A.738.738,0,0,0,76.517,21.185ZM85.5,23.561a11.014,11.014,0,0,1-7.144-2.624c3.241-1.076,4.44-2.384,4.884-3.256a5.267,5.267,0,0,0,2.071.422h.167a5.292,5.292,0,0,0,2.224-.494c.414.872,1.592,2.224,4.927,3.328A10.96,10.96,0,0,1,85.5,23.561ZM81.459,10.189v-.044c.174-3.786,2.965-4.084,3.823-4.084h.233c.85,0,3.648.3,3.823,4.084v.044c.007.036.363,3.539-1.272,5.378a3.361,3.361,0,0,1-2.638,1.1h-.044a3.374,3.374,0,0,1-2.638-1.1C81.1,13.743,81.452,10.225,81.459,10.189ZM85.5,1.439A11.056,11.056,0,0,1,93.807,19.8c-4.695-1.366-4.876-3.023-4.876-3.045v.036h-.051c.087-.087.174-.174.262-.269,2-2.246,1.664-6.09,1.628-6.468-.2-4.012-2.951-5.436-5.254-5.436h-.233c-2.3,0-5.065,1.424-5.254,5.436-.036.371-.363,4.215,1.628,6.468.116.131.24.254.363.371-.153.422-.923,1.759-4.826,2.9A11.05,11.05,0,0,1,85.5,1.439Z"
      transform="translate(-73)"
    />
  </svg>
);

export default UserIcon;
